export default "__VITE_ASSET__BhZcm_wT__"